import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

// Perks & Discounts static page. Entered from the content-managed "View perks
// & discounts" CTA on the Benefits landing page, which deeplinks to
// APP_MANAGED_ROUTES.PERKS. Rendered entirely OOTB: the whole page is
// server-driven, so nothing here is conditional.
//
// The tree's own root fires a showModal onLoad (the attestation gate), so the
// page mounts dimmed behind that modal on every visit. That is server-driven
// too — no client-side registration is needed, showModal/dismissModal are SDK
// defaults.
export const PerksPage = () => (
  <MasonryPage
    screenName="Perks & Discounts"
    titleMessageId="STR_PERKS_AND_DISCOUNTS"
    rootNodeId={MASONRY.ROOT_NODE_ID_PERKS}
  />
);
